// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3JRKg","content":"ManualTimeModal_content__3lmV3"};